<p-table
  #dt1
  [value]="products"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines"
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. proizvoda od ukupno {totalRecords}"
  [globalFilterFields]="['label', 'name']"
>
  <ng-template pTemplate="caption">
    <div class="page-control flex align-items-start">
      <div class="grid w-100">
        <div class="col-3">
          <span class="p-input-icon-left w-100">
            <i class="pi pi-search"></i>
            <input
              pInputText
              class="w-100"
              type="text"
              (input)="dt1.filterGlobal($event.target.value, 'contains')"
              placeholder="Pretraži šifru ili naziv"
            />
          </span>
        </div>
        <div class="col-3">
          <p-columnFilter
            field="product_type"
            styleClass="w-100"
            matchMode="in"
            optionLabel="newproperty"
            [showMenu]="false"
            [showMatchModes]="false"
            [showOperator]="false"
            [showAddButton]="false"
          >
            <ng-template pTemplate="header">
              <div class="px-3 pt-3 p-0">
                <span class="text-bold">Izaberi tip</span>
              </div>
            </ng-template>
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [ngModel]="value"
                [options]="productTypes"
                placeholder="Svi tipovi"
                (onChange)="filter($event.value)"
                optionLabel="name"
              >
                <ng-template
                  let-option
                  pTemplate="item"
                >
                  <div class="p-multiselect-representative-option">
                    <span class="ml-1">{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </div>
      </div>
      <div class="btn-group">
        <a
          [routerLink]="['add']"
          class="main-btn"
        >Dodaj proizvod <i class="pi pi-plus"></i>
        </a>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="label">
        <div class="flex justify-content-between align-items-center">
          Šifra proizvoda
          <p-sortIcon field="label"></p-sortIcon>
          <!-- <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> -->
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Naziv
          <!-- <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> -->
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Redosled operacija
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Tip
          <!-- <p-columnFilter type="text" field="product_type.name" display="menu"></p-columnFilter> -->
        </div>
      </th>
      <th style="width: 10rem">
        <div class="flex justify-content-between align-items-center">
          Akcija
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-products
  >
    <tr>
      <td>
        {{ products.label }}
      </td>
      <td>
        <span class="image-text">{{ products.name }}</span>
      </td>
      <td>
        <span class="image-text">
          <span
            class="badge mr-1"
            *ngFor="let operations of products.operations"
          >
            {{ operations.operation.label }}
          </span>
        </span>
      </td>
      <td>
        {{ products.product_type.name }}
      </td>
      <td class="text-center">
        <a
          class="second-btn small-btn mr-2"
          pTooltip="Izmeni"
          tooltipPosition="top"
          (click)="onEditProduct(products)"
          [routerLink]="['edit', products.id]"
        >
          <i class="pi pi-pencil"></i>
        </a>

        <button
          class="second-btn small-btn"
          type="button"
          pTooltip="Izbriši"
          tooltipPosition="top"
          (click)="onDeleteProduct(products.id)"
        >
          <i class="pi pi-trash"></i>
        </button>

        <a
          class="second-btn small-btn ml-2"
          pTooltip="Kopiraj"
          tooltipPosition="top"
          (click)="onCopyProduct(products)"
          [routerLink]="['copy']"
        >
          <i class="pi pi-copy"></i>
        </a>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">Ni jedan proizvod nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>
